/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from 'react'

import XOverlay from 'xui/components/XOverlay'
import HStack from 'xui/components/HStack'
import Box from 'xui/components/Box'
import XText from 'xui/components/XText'
import XButton from 'xui/components/XButton'
import XRadioList from 'xui/components/XRadioList'
import _ from 'lodash'
import * as util from 'x/utils/util'
import { IMKPChannelDetail } from 'x/index'
import HelpButton from 'xui/components/HelpButton'
import VStack from 'xui/components/VStack'
import Segment from 'xui/components/Segment'
import XDateRangePicker from 'xui/components/XDateRangePicker'
import dayjs from 'dayjs'
import CONS from 'x/config/constants'

interface IOverlaySyncMKPProductProps {
  channel: IMKPChannelDetail
  onClose: () => void
  isOverlayVisible: boolean
  onSubmit: (forceSync: boolean, dateTime?: { startDate: string; endDate: string }, method?: 'CREATE' | 'UPDATE') => void
}

interface IDataList {
  label: string
  index: number
}

const dataList: IDataList[] = [
  {
    label: 'จากอัพเดทล่าสุด (แนะนำ)',
    index: 0,
  },
  {
    label: 'ทั้งหมด (ใช้เวลานานกว่า)',
    index: 1,
  },
]

const _renderAgreement = (onPressOpenOverlay: () => void) => <HelpButton onPress={() => onPressOpenOverlay()} />

const toDate = {
  startDate: dayjs().hour(0).minute(0).second(0).millisecond(0),
  endDate: dayjs().hour(23).minute(59).second(59).millisecond(999),
}

const OverlaySyncMKPProduct: React.FC<IOverlaySyncMKPProductProps> = ({ channel, onClose, isOverlayVisible, onSubmit }) => {
  // const [selectedIndex, updateSelectedIndex] = useState(0)
  const [selectedUpdateSyncModeIndex, updateSyncMode] = useState(0)
  const [selectedUpdateSyncMethodIndex, updateSyncMethod] = useState(0)
  const [selectedUpdateSyncHoureIndex, updateSyncHour] = useState(0)

  const [dateTime, updateDateTime] = useState(toDate)

  if (_.isNil(channel)) {
    return null
  }

  // const onRadioChange = (item) => {
  //   // console.log('item => ', item)
  //   updateSelectedIndex(item.index)
  // }

  const submitBtn = () => {
    if (isLineMkp) {
      onSubmit(true)
    } else {
      const newDateTime = {
        startDate: dayjs(dateTime.startDate).format(CONS.SERVER_DATETIME_FORMAT_WITH_MILLISECONDS),
        endDate: dayjs(dateTime.endDate).format(CONS.SERVER_DATETIME_FORMAT_WITH_MILLISECONDS),
      }
      const forceSync = selectedUpdateSyncModeIndex === 1
      if (forceSync) {
        onSubmit(forceSync)
      } else if (selectedUpdateSyncModeIndex === 0) {
        onSubmit(false)
      } else {
        // console.log('newDateTime => ', newDateTime)
        // const METHOD = selectedUpdateSyncMethodIndex === 0 ? 'CREATE' : 'UPDATE'
        const METHOD = selectedUpdateSyncMethodIndex === 0 && !isShopeeOrLine ? 'CREATE' : 'UPDATE'
        onSubmit(false, newDateTime, METHOD)
      }
    }
  }

  const onDateChange = ({ begin, end }) => {
    // console.log('TIME begin !!! => ', dayjs(begin).format(CONS.SERVER_DATETIME_FORMAT))
    // console.log('TIME end !!! => ', dayjs(end).format(CONS.SERVER_DATETIME_FORMAT))
    // const endchangeSecondTime = util.changeSecondTime(end, 59)
    const newState = { startDate: begin, endDate: end }
    updateDateTime(newState)
    // onChangeSegmentIndexFunction(3)
    // this.setState(newState)
  }

  const channelMKPName = util.getMKPName(channel.mkp_id)
  const isLineMkp = channel.mkp_id === 4
  const isShopeeOrLine = channel.mkp_id === 1 || channel.mkp_id === 4

  const renderBody = () => {
    const onChangeSegmentUpdateSyncModeIndex = (newIndex: number) => {
      if (newIndex === 2) {
        const threHours = {
          startDate: dayjs().subtract(1, 'hours').second(0).millisecond(0),
          endDate: dayjs().second(0).millisecond(0),
        }
        updateDateTime(threHours)
      }
      updateSyncMode(newIndex)
    }
    const onChangeSegmentUpdateSyncMethodIndex = (newIndex: number) => {
      updateSyncMethod(newIndex)
    }
    const onChangeSegmentUpdateSyncHourIndex = (newIndex: number) => {
      // console.log('newIndex => ', newIndex)
      updateSyncHour(newIndex)
      if (newIndex === 0) {
        const threHours = {
          startDate: dayjs().subtract(1, 'hours').second(0).millisecond(0),
          endDate: dayjs().second(0).millisecond(0),
        }
        updateDateTime(threHours)
      } else if (newIndex === 1) {
        const threHours = {
          startDate: dayjs().subtract(3, 'hours').second(0).millisecond(0),
          endDate: dayjs().second(0).millisecond(0),
        }
        updateDateTime(threHours)
      } else if (newIndex === 2) {
        const fifteenDay = {
          startDate: dayjs().subtract(6, 'hours'),
          endDate: dayjs().second(0).millisecond(0),
        }
        updateDateTime(fifteenDay)
      }
    }
    if (selectedUpdateSyncModeIndex === 1) {
      return (
        <VStack mt='1' space={'1'}>
          <Segment
            options={['อัพเดทล่าสุด', 'ทั้งหมด', 'ระบุเวลา']}
            selectedIndex={selectedUpdateSyncModeIndex}
            onSegmentChange={onChangeSegmentUpdateSyncModeIndex}
          />
          <XText>ใช้เวลานานกว่า เนื่องจากซิงก์สินค้าทุกรายการที่มีในร้าน</XText>
        </VStack>
      )
    }
    return (
      <VStack mt='1' space={'1'}>
        <Segment
          options={['อัพเดทล่าสุด', 'ทั้งหมด', 'ระบุเวลา']}
          selectedIndex={selectedUpdateSyncModeIndex}
          onSegmentChange={onChangeSegmentUpdateSyncModeIndex}
        />

        {selectedUpdateSyncModeIndex === 0 || isShopeeOrLine ? null : (
          <VStack>
            <XText variant='inactive'>ช่วงเวลาที่สินค้า...</XText>
            <Segment
              options={['ถูกสร้าง', 'ถูกอัพเดท']}
              selectedIndex={selectedUpdateSyncMethodIndex}
              onSegmentChange={onChangeSegmentUpdateSyncMethodIndex}
            />
          </VStack>
        )}

        {selectedUpdateSyncModeIndex === 0 ? null : (
          <VStack>
            <XText variant='inactive'>{isShopeeOrLine ? 'ถูกอัพเดทภายใน...' : 'ภายใน...'}</XText>
            <Segment
              options={['1 ชม.', '3 ชม.', '6 ชม.', 'ระบุ']}
              selectedIndex={selectedUpdateSyncHoureIndex}
              onSegmentChange={onChangeSegmentUpdateSyncHourIndex}
            />
          </VStack>
        )}

        {selectedUpdateSyncModeIndex === 0 && selectedUpdateSyncHoureIndex === 0 ? (
          <XText>ซิงค์เฉพาะสินค้าที่มีการสร้างหรืออัพเดท นับจากเวลาที่ระบบซิงค์ครั้งสุดท้าย</XText>
        ) : null}
        {selectedUpdateSyncModeIndex === 2 ? (
          <VStack>
            <Box justifyContent='center' w='full' h='24'>
              <XDateRangePicker
                // allowOnlyDaysFromToday={31}
                allowDateRangeLimitDays={15}
                selectedDates={{ begin: dateTime.startDate, end: dateTime.endDate }}
                onChangeDate={(newDates) => onDateChange(newDates)}
                showTime
              />
            </Box>
            <XText variant='primary' textAlign='center'>
              สามารถซิงค์สูงสุดครั้งละ 15 วัน
            </XText>
          </VStack>
        ) : null}
      </VStack>
    )
  }
  const _renderOverlay = () => (
    <XOverlay
      contentStyle={{ width: 310, alignSelf: 'center' }}
      visible={isOverlayVisible}
      // webNumColumns={1}
      onRequestClose={() => onClose()}
    >
      <Box w='full' p='2' bgColor='white' borderRadius='md'>
        <HStack alignItems='center'>
          <XText variant='active' bold>
            {`ซิงค์ข้อมูลสินค้าจาก ${channelMKPName}`}
          </XText>
          {/* <XHelpModal
            key='sync_sync_product'
            headerTitle='ซิงค์ข้อมูลสินค้าจากช่องทางขาย'
            FAQ={FAQ.MKP_SYNC_PRODUCT}
            initiateOpenIndex={3}
            renderButton={(onPressOpenOverlay: () => void) => _renderAgreement(onPressOpenOverlay)}
          /> */}
        </HStack>
        {isLineMkp ? (
          <XText>ข้อมูลของสินค้าทุกรายการบนร้านใน LINE SHOPPING จะถูกซิงค์และประมวลผล (อาจใช้เวลาซักครู่ถ้าสินค้ามีจำนวนมากรายการ)</XText>
        ) : null}
        {!isLineMkp ? renderBody() : null}
        <XButton mt='2' onPress={() => submitBtn()}>
          ดำเนินการซิงค์
        </XButton>
      </Box>
    </XOverlay>
  )

  // Main render
  return (
    <>
      {/* {_renderControlButton()} */}
      {_renderOverlay()}
    </>
  )
}

export default OverlaySyncMKPProduct
